
export const goalQueryKeys = {
  all: ['goals'],
  user: (userId: string) => ['goals', userId],
  byId: (userId: string, goalId: string) => ['goals', userId, goalId],
};
